import { useEffect } from 'react';
import useProductActions from '../hooks/useProductActions';
import { ProductType } from '../interface/interface';
import Products from './Products';

export default function ProductTypes({
  productType,
}: Readonly<{
  productType: ProductType;
}>) {
  const [
    loading,
    dataprops,
    searchProps,
    filterProps,
    sortProps,
    paginationProps,
  ] = useProductActions(productType);

  useEffect(() => {
    localStorage.removeItem('productCategroy');
    localStorage.removeItem('productFormulation');
    localStorage.removeItem('productCondition');
  }, []);

  return (
    <Products
      dataProps={dataprops}
      loading={loading}
      searchProps={searchProps}
      filterProps={filterProps}
      sortProps={sortProps}
      paginationProps={paginationProps}
      type={productType}
    />
  );
}
